import React from 'react'
import { Navbar, Button } from 'components/elements'
import cloudinary from 'cloudinary-core'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from 'constants/images/cloudinary'
import { userPhotoID } from 'constants/images/sizesAndQuality'
import { withRouter } from 'react-router-dom'
import { isConversationFeatureEnabled } from '../../../utils/featureFlag'
import { popularLocations } from 'constants/locations'
import { popularBrands } from 'constants/brands'
import TwistedAccordion from 'components/elements/accordion'
import LanguageTranslator from '../languageTranslator'
import './../header.sass'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

const checkAndRedirect = (props) => {
  if (props.isAuth) {
    props.history.push('/list/motorcycle')
  } else {
    props.loginModalFunction('signup', props.authObject.openSignUp)
  }
}

const ListCTA = (props) => (
  <span>
    {!props.isAuth && (
      <Navbar.Item className="custom-menu-item" href="/list-your-motorcycle">
        List Your Bike
      </Navbar.Item>
    )}

    {props.isAuth && (
      <Navbar.Item dropdown hoverable href="/list-your-motorcycle">
        <Navbar.Link>
          List Your Bike <i className="fal fa-down-angle"></i>
        </Navbar.Link>
        <Navbar.Dropdown>
          <Navbar.Item
            onClick={() => {
              checkAndRedirect(props)
            }}
          >
            List Your Bike Now
          </Navbar.Item>
          <Navbar.Item href="/list-your-motorcycle">
            Learn more about listing
          </Navbar.Item>
        </Navbar.Dropdown>
      </Navbar.Item>
    )}
  </span>
)

const CalculateEarnings = (props) => (
  <Button
    className="ride-for-free-btn is-yellow-btn"
    color="primary"
    onClick={() => {
      props.history.push('/list-your-motorcycle/calculator')
    }}
  >
    Calculate Earnings
  </Button>
)

const LearnDropDown = ({ isAuth }) => (
  <Navbar.Item dropdown hoverable>
    <Navbar.Link>About</Navbar.Link>
    <Navbar.Dropdown right>
      <div className='navbar-item locations'>
        <TwistedAccordion
          items={popularLocations}
          title="Popular Locations"
        />
      </div>
      <div className='navbar-item brands'>
        <TwistedAccordion
          items={popularBrands}
          title="Popular Brands"
        />
      </div>
      <hr className="dropdown-divider" />
      <Navbar.Item href="/how-it-works">How It Works</Navbar.Item>
      <Navbar.Item href="/how-it-works/insurance">Insurance</Navbar.Item>
      <Navbar.Item href="/reviews">Customer Reviews</Navbar.Item>
      {isAuth && 
        <Navbar.Item
          href={'https://support.twistedroad.com'}
          target="_blank"
          rel="noopener noreferrer"
        >
          Help Center
        </Navbar.Item>
      }
      <hr className="dropdown-divider" />
      <Navbar.Item href="/blog">Blog</Navbar.Item>
      <Navbar.Item href="/events">Events</Navbar.Item>
      <Navbar.Item href="https://merch.twistedroad.com/" target="_blank">
        Merch
      </Navbar.Item>
      <Navbar.Item
        href="https://mailchi.mp/twistedroad/holiday-gift-card-2025"
        target="_blank"
      >
        Gift Cards
      </Navbar.Item>
      {!isAuth && (
        <>
          <hr className="dropdown-divider" />
          <Navbar.Item href={'/contact-us'}>Contact Us</Navbar.Item>
          <Navbar.Item
            href={'https://support.twistedroad.com'}
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Center
          </Navbar.Item>
        </>
      )}
    </Navbar.Dropdown>
  </Navbar.Item>
)

const DashBoardDropDown = (props) => (
  <>
    {props.isAuth && (
      <Navbar.Item dropdown hoverable>
        <Navbar.Link>Dashboard</Navbar.Link>
        <Navbar.Dropdown right>
          <Navbar.Item href="/dashboard/mytrips">My Trips</Navbar.Item>
          <Navbar.Item href="/dashboard/reservations">Reservations</Navbar.Item>
          <Navbar.Item href="/dashboard/garage">Listings</Navbar.Item>
          <Navbar.Item href="/dashboard/favorites">
            Saved Motorcycles
          </Navbar.Item>
        </Navbar.Dropdown>
      </Navbar.Item>
    )}
  </>
)

const LoginSignUp = (props) => (
  <>
    {!props.isAuth && (
      <>
        <Navbar.Item
          href="#"
          onClick={() =>
            props.loginModalFunction('login', props.authObject.openLogin)
          }
        >
          Login
        </Navbar.Item>
        <Navbar.Item
          href="#"
          onClick={() =>
            props.loginModalFunction('signup', props.authObject.openSignUp)
          }
        >
          Sign Up
        </Navbar.Item>
      </>
    )}
  </>
)

const loggedInMenuTrigger = (userAvatarURL, userAvatarID) => (
  <img
    height="28px"
    width="28px"
    src={cl.url(userPhotoID(userAvatarID), {
      gravity: 'center',
      height: 60,
      width: 60,
      crop: 'fill',
      format: 'jpg',
      quality: 80,
    })}
    alt="Logged In"
    className="is-rounded"
  />
)

const UserMenu = (props) => {
  const {
    authObject: {
      state: { userID, userAvatar, userAvatarID, unreadMessagesCount },
      logOut,
    },
    logoutFunction,
  } = props

  return (
    <>
      {props.isAuth && (
        <Navbar.Item dropdown hoverable>
          <Navbar.Link className="is-arrowless" id="user-account">
            {/* Make this a component */}
            {loggedInMenuTrigger(userAvatar, userAvatarID)}
            {unreadMessagesCount > 0 && isConversationFeatureEnabled() && (
              <span className="tag is-danger is-rounded badge">
                {unreadMessagesCount}
              </span>
            )}
          </Navbar.Link>
          <Navbar.Dropdown right>
            <Navbar.Item href={'/one-two-free'}>Ride For Free</Navbar.Item>
            <Navbar.Item href={'/users/' + userID}>My Profile</Navbar.Item>
            <Navbar.Item href={'/account/edit-profile'}>
              Edit Account
            </Navbar.Item>
            {isConversationFeatureEnabled() && (
              <Navbar.Item href={'/conversations'}>
                My Messages
                {unreadMessagesCount > 0 && isConversationFeatureEnabled() && (
                  <div className="tag is-danger is-rounded in-menu-unread-count">
                    {unreadMessagesCount || 0}
                  </div>
                )}
              </Navbar.Item>
            )}
            <hr className="dropdown-divider" />
            <Navbar.Item href={'/contact-us'}>Contact Us</Navbar.Item>
            <Navbar.Item
              href={'https://support.twistedroad.com'}
              target="_blank"
              rel="noopener noreferrer"
            >
              Help Center
            </Navbar.Item>
            <hr className="dropdown-divider" />
            <Navbar.Item onClick={() => logoutFunction(logOut)}>
              Logout
            </Navbar.Item>
          </Navbar.Dropdown>
        </Navbar.Item>
      )}
    </>
  )
}

const MenuRight = (props) => (
  <Navbar color={'black'} className="is-spaced m-0 p-0">
    <Navbar.Menu>
      <Navbar.Container position="end">
        <CalculateEarnings {...props} />
        <ListCTA {...props} />
        <LearnDropDown isAuth={props.isAuth} />
        <DashBoardDropDown isAuth={props.isAuth} />
        <LoginSignUp {...props} />
        <UserMenu {...props} />
        <LanguageTranslator />
      </Navbar.Container>
    </Navbar.Menu>
  </Navbar>
)

export default withRouter(MenuRight)
